"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("@xstate/react");
const xstate_1 = require("xstate");
const prop_types_1 = require("prop-types");
const provider_components_1 = require("@kyruus/provider-components");
const utils_1 = require("../../lib/utils");
const xstate_2 = require("../../lib/constants/xstate");
const styles_1 = require("./styles");
const ErrorPageSharedContent_1 = __importDefault(require("./ErrorPageSharedContent"));
const ErrorPageCancelDisabled = ({ service }) => {
    const [state] = (0, react_2.useService)(service);
    const { appointment: { patientRelationship = '', patientPurpose = '', startDateTime = '' }, locationId, locations, provider = {} } = state.context;
    // Sidebar adapter
    const appointmentQuery = {
        patientRel: patientRelationship,
        purpose: {
            name: patientPurpose
        }
    };
    const selectedAppointment = {
        start_datetime: startDateTime,
        location_id: locationId
    };
    const providerPhone = (0, utils_1.hasProvider)(provider) && (0, provider_components_1.getProviderContactPhone)(provider);
    let bannerText = '';
    if ((0, utils_1.subStateMatchHelper)(xstate_2.states.cancelDisabledPage, state)) {
        if (providerPhone) {
            bannerText = 'cancelationDisabledBanner';
        }
        else {
            bannerText = 'cancelationDisabledBannerNoProvider';
        }
    }
    else if ((0, utils_1.subStateMatchHelper)(xstate_2.states.cancelExpiredPage, state)) {
        if (providerPhone) {
            bannerText = 'cancelationExpiredBanner';
        }
        else {
            bannerText = 'cancelationExpiredBannerNoProvider';
        }
    }
    else if (state.matches(xstate_2.states.appointmentMissed)) {
        if (providerPhone) {
            bannerText = 'appointmentMissed';
        }
        else {
            bannerText = 'appointmentMissedNoProvider';
        }
    }
    else {
        bannerText = 'cancelationDisabledBannerNoProvider';
    }
    return (react_1.default.createElement(styles_1.CancelDisabledWrapper, { "data-testid": "CancelDisabled" },
        react_1.default.createElement(ErrorPageSharedContent_1.default, { errorHeadingText: 'cancelationDisabledHeading', bannerText: bannerText, phone: providerPhone || '' }),
        (0, utils_1.hasProvider)(provider) && (react_1.default.createElement(styles_1.SideBarWrapper, null,
            react_1.default.createElement(provider_components_1.ProviderSidebar, { provider: provider, locations: locations, appointmentQuery: appointmentQuery, selectedAppointment: selectedAppointment, showSchedulingHelpBanner: false })))));
};
ErrorPageCancelDisabled.propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired
};
exports.default = ErrorPageCancelDisabled;
//# sourceMappingURL=ErrorPageCancelDisabled.js.map